module.exports = __webpack_public_path__ + "img/print-logo.392622ef.png";